import { SeoBlock } from "@/components/sections/sameday-delivery/SamedaySeoBlocksSection";
import SeoOnly from "@/components/seo/SeoOnly";

/**
 * Expandable SEO copy for `/why-dank`, same pattern as mail-order “weed delivery in Alberta” blocks,
 * tuned for “why choose Dank” positioning rather than mail-order logistics.
 */
export default function WhyDankSeoBlocksSection() {
  return (
    <SeoOnly>
      <section className="w-full max-w-none" aria-label="Why Dank Cannabis">
      <div className="flex w-full flex-col gap-6">
        <SeoBlock title="Why shop at Dank Cannabis in Alberta">
          Dank is built for people who care about quality, clarity, and a retail experience that respects their time.
          Browse online for pickup, visit a Calgary store, or use delivery where it&apos;s available, and you&apos;ll
          find curated menus, clear product details, and staff who actually live cannabis culture. From flower and
          pre-rolls to concentrates, edibles, beverages, and accessories, we stock what Albertans actually reach for:
          consistent potency, honest recommendations, and fair value.
        </SeoBlock>
        <SeoBlock title="Calgary cannabis retail, more than one way to shop">
          Our roots are in Calgary and our goal is simple: meet customers where they are. Order ahead and grab your
          bag when it&apos;s ready. Compare strains in person with a budtender who knows what you&apos;re into. Use
          same-day delivery or mail order where it&apos;s offered. Dank ties those paths together so you&apos;re not
          bouncing between menus and policies. We earn your trust every visit with selection, education, and service
          that feels human.
        </SeoBlock>
      </div>
    </section>
    </SeoOnly>
  );
}
